export default __webpack_public_path__ + "static/media/MarkW07-Regular.79626005.woff2";